import { render } from "./NewDashboard.vue?vue&type=template&id=e04f856e&scoped=true"
import script from "./NewDashboard.vue?vue&type=script&lang=js"
export * from "./NewDashboard.vue?vue&type=script&lang=js"

import "./NewDashboard.vue?vue&type=style&index=0&id=e04f856e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04f856e"]])

export default __exports__